import { render, staticRenderFns } from "./chatDetail.vue?vue&type=template&id=2a279f7f&scoped=true"
import script from "./chatDetail.vue?vue&type=script&lang=js"
export * from "./chatDetail.vue?vue&type=script&lang=js"
import style0 from "./chatDetail.vue?vue&type=style&index=0&id=2a279f7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a279f7f",
  null
  
)

export default component.exports